module.exports = __webpack_public_path__ + "static/7-287c8b93a8cb2c3a9520388f70da3daa.png";